import { render, staticRenderFns } from "./LabDashboard.vue?vue&type=template&id=6dbee8b7&scoped=true&"
import script from "./LabDashboard.vue?vue&type=script&lang=js&"
export * from "./LabDashboard.vue?vue&type=script&lang=js&"
import style0 from "./LabDashboard.vue?vue&type=style&index=0&id=6dbee8b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbee8b7",
  null
  
)

export default component.exports